/*
 * Copyright (c) 2026 237 Solutions Group Co., Ltd.
 * Developed by Patcharapong Ponzue (contact@ibig.dev)
 *
 * Vuex Store Module - Credit Package CRUD
 */

// eslint-disable-next-line no-unused-vars
import axios from "@axios";

export default {
  namespaced: true,
  state: {
    respData: null,
  },
  getters: {},
  mutations: {
    GET(state, payload) {
      state.respData = payload;
    },
    ADD(state, payload) {
      if (state.respData != null) {
        state.respData.data.push(payload);
        // eslint-disable-next-line operator-assignment
        state.respData.max = state.respData.max + 1;
      } else {
        state.respData = { data: [payload], max: 1 };
      }
    },
    UPDATE(state, payload) {
      const productIndex = state.respData.data.findIndex(
        (p) => p._id === payload._id,
      );
      if (productIndex > -1) {
        Object.assign(state.respData.data[productIndex], payload);
      }
    },
    REMOVE(state, id) {
      if (state.respData != null) {
        const ItemIndex = state.respData.data.findIndex((p) => p._id === id);
        state.respData.data.splice(ItemIndex, 1);
        // eslint-disable-next-line operator-assignment
        state.respData.max = state.respData.max - 1;
      }
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    get({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `/api/web/application/eCommerce/creditPackage/get?pageSize=${item.pageSize}&currentPage=${item.currentPage}&searchQuery=${item.searchQuery}`,
          )
          .then((response) => {
            commit("GET", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // eslint-disable-next-line no-unused-vars
    add({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .post("/api/web/application/eCommerce/creditPackage/add", item)
          .then((response) => {
            commit("ADD", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // eslint-disable-next-line no-unused-vars
    update({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put("/api/web/application/eCommerce/creditPackage/update", item)
          .then((response) => {
            commit("UPDATE", response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // eslint-disable-next-line no-unused-vars
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/web/application/eCommerce/creditPackage/remove`, {
            data: { _id: id },
          })
          .then((response) => {
            commit("REMOVE", id);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
